import { SocialStarterPlanTypesEnum } from '@ctct/domain-layer';

const baseI18n = 'application-layer.email-plans.social-comparison-table';

/**
 * Static Social Starter comparison table content definition.
 *
 * This file intentionally contains only a JSON-like structure (no logic, no queries).
 * Dynamic pieces such as translations, pricing, and "recommended" variants are applied
 * in the PlanComparisonTableService.
 */
export default {
  baseI18n,
  plans: [
    {
      id: SocialStarterPlanTypesEnum.Silver,
      nameKey: 'columns.pro',
    },
    {
      id: SocialStarterPlanTypesEnum.Bronze,
      nameKey: 'columns.lite',
    },
  ],
  groups: [
    {
      id: 'social-features',
      headingKey: 'heading',
      features: [
        {
          id: 'account-connections',
          nameKey: 'rows.account-connections.label',
          parameters: [
            {
              id: SocialStarterPlanTypesEnum.Silver,
              valueKey: 'rows.account-connections.pro',
            },
            {
              id: SocialStarterPlanTypesEnum.Bronze,
              valueKey: 'rows.account-connections.lite',
            },
          ],
        },
        {
          id: 'ai-generation-1',
          nameKey: 'rows.ai-generation-1.label',
          parameters: [
            {
              id: SocialStarterPlanTypesEnum.Silver,
              valueKey: 'rows.ai-generation-1.pro',
            },
            {
              id: SocialStarterPlanTypesEnum.Bronze,
              valueKey: 'rows.ai-generation-1.lite',
            },
          ],
        },
        {
          id: 'link-in-bio',
          nameKey: 'rows.link-in-bio.label',
          parameters: [
            {
              id: SocialStarterPlanTypesEnum.Silver,
              valueKey: 'rows.link-in-bio.pro',
            },
            {
              id: SocialStarterPlanTypesEnum.Bronze,
              valueKey: 'rows.link-in-bio.lite',
            },
          ],
        },
        {
          id: 'reporting',
          nameKey: 'rows.reporting.label',
          parameters: [
            {
              id: SocialStarterPlanTypesEnum.Silver,
              valueKey: 'rows.reporting.pro',
            },
            {
              id: SocialStarterPlanTypesEnum.Bronze,
              valueKey: 'rows.reporting.lite',
            },
          ],
        },
      ],
    },
  ],
} as const;
